import Vue from 'vue'
import Vuex from 'vuex'

export default class {
  constructor() {
    Vue.use(Vuex)
    this.store = new Vuex.Store({
      state: {
        loading: true,
        error: false,
        error_msg: null,
        labels: [],
        configurations: [],
        results: [],
        visibleResultId: null,
        session: {
          step: 1,
        },
        // session: {
        //     Appliance: 1,
        //     Blower: 1,
        //     Exhaust: 2,
        //     Fuel: 1,
        //     Ducting: null,
        //     Width: 1,
        //     step:6,
        // }
      },
      getters: {
        get: (state) => (key) => {
          if (Array.isArray(key)) {
            let _state = state
            key.every((k) => (_state[k] ? ((_state = _state[k]), true) : ((_state = false), false)))
            return _state
          }
          return state[key]
        },
      },
      mutations: {
        write_state(state, payload) {
          state[payload.key] = payload.value
        },
        setStep(state, data) {
          state.session.step = data
        },
        setStepOption(state, data) {
          Vue.set(state.session, data.step, data.value)
        },
      },
      actions: {
        fetchData({ commit }, endpoint) {
          return new Promise((resolve) => {
            fetch(endpoint)
              .then((res) => res.json())
              .then((data) => {
                if (data.error) {
                  commit('write_state', { key: 'error_msg', value: data.error })
                  commit('write_state', { key: 'error', value: true })
                  return
                }
                commit('write_state', { key: 'labels', value: data.labels })
                commit('write_state', { key: 'configurations', value: data.configurations })
              })
              .catch((error) => {
                console.error(error)
                commit('write_state', { key: 'error', value: true })
              })
              .finally(() => {
                setTimeout(() => {
                  commit('write_state', { key: 'loading', value: false })
                  resolve()
                }, 750)
              })
          })
        },
        fetchResults({ commit }, endpoint) {
          return new Promise((resolve) => {
            fetch(endpoint)
              .then((res) => res.json())
              .then((data) => {
                if (data.error) {
                  commit('write_state', { key: 'error_msg', value: data.error })
                  commit('write_state', { key: 'error', value: true })
                  return
                }
                commit('write_state', { key: 'results', value: data.results })
              })
              .catch((error) => {
                console.error(error)
                commit('write_state', { key: 'error', value: true })
              })
              .finally(() => {
                setTimeout(() => {
                  commit('write_state', { key: 'loading', value: false })
                  resolve()
                }, 750)
              })
          })
        },
      },
    })
  }
}
